import React, { useState, useEffect, useCallback } from "react"
import { useEmblaCarousel } from "embla-carousel/react"
import styled from "styled-components"

const StyledContentCarouselCanvas = styled.div`
  display: flex;
  align-items: ${(props) => props.alignItems};
`

const StyledStandardCarousel = styled.div`
  position: relative;
`

const StyledCarouselNav = styled.nav`
  position: absolute;
  bottom: 2.5rem;
  left: 0;
  z-index: 10;
  width: 100%;
  padding-bottom: 1.5rem;
  padding-top: 1.5rem;
  padding: 0 ${(props) => props.theme.padding.hMobile};
  display: flex;
  align-items: center;
  @media ${(props) => props.theme.breakpoints.medium} {
    padding: 0 ${(props) => props.theme.padding.hDesk};
  }
`
const CarouselButton = styled.button`
  width: 78px;
  height: 7px;
  position: relative;
  background: rgba(213, 213, 213, 0.3);
  margin-right: 0.5rem;
  ${(props) =>
    props.selected &&
    `
    background: ${props.theme.colors.brandColor};
  `}
`

export const AutoPlayCarousel = ({ children }) => {
  const [emblaRef, embla] = useEmblaCarousel({ loop: false, dragFree: false })

  const [selectedIndex, setSelectedIndex] = useState(0)
  const [scrollSnaps, setScrollSnaps] = useState([])
  const scrollTo = useCallback((index) => embla.scrollTo(index), [embla])

  useEffect(() => {
    const onSelect = () => {
      setSelectedIndex(embla.selectedScrollSnap())
    }
    if (embla) {
      setScrollSnaps(embla.scrollSnapList())
      embla.on("select", onSelect)
      onSelect()
    }
    return () => embla && embla.destroy()
  }, [embla])

  return (
    <StyledStandardCarousel>
      <div ref={emblaRef}>
        <StyledContentCarouselCanvas>{children}</StyledContentCarouselCanvas>
      </div>
      <StyledCarouselNav>
        {scrollSnaps?.map((snap, index) => (
          <CarouselButton
            selected={index === selectedIndex}
            onClick={() => scrollTo(index)}
            key={`carouselButton-${index}`}
          />
        ))}
      </StyledCarouselNav>
    </StyledStandardCarousel>
  )
}
